import { theme } from '@contrast-security-inc/design-system-foundations'
import { css } from '@emotion/css'

export const styles = {
  Stat: (isDisabled: boolean) => css`
    margin-left: 50px;
    display: flex;
    flex-direction: column;
    height: 80px;
    justify-content: space-between;
    color: ${isDisabled ? theme.color.neutral50 : theme.color.neutral70};
  `,
  StatLink: (isLink: boolean) => css`
    font-weight: 700;
    font-size: 50px;
    line-height: 50px;
    text-decoration: none;
    color: ${isLink ? '#0da1a9' : 'inherit'};
    ${isLink && 'cursor: pointer;'}
  `,
  StatInfo: css`
    display: flex;
    text-transform: capitalize;
    color: inherit;
  `,
  StatTotal: (isLink: boolean) => css`
    font-size: 32px;
    color: ${isLink ? '#8EC4C7' : theme.color.neutral50};
  `
}
